<template>
<div>
    <div class="orderDetail">
        <el-drawer title="订单详情" :visible.sync="$store.state['zsm-order'].orderDetailDrawer">

            <div class="orderDetailBox">

                <div class="orderDetailCon">
                    <p class="font-size-smg">基本信息</p>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">订单号</div>
                        <div>{{ orderDetailInfo.orderNo }}</div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">订单状态</div>
                        <div v-if="orderDetailInfo.backFlag&&orderDetailInfo.backFlag==1" class="buy buy2">已退款</div>
                        <div v-else-if="orderDetailInfo.payFlag=='1'" class="buy">已购买</div>
                        <div v-else-if="orderDetailInfo.payFlag=='0'" class="buy buy2">未支付</div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">下单时间</div>
                        <div>{{ orderDetailInfo.createDate }}</div>
                    </div>
                </div>

                <div class="orderDetailCon">
                    <p class="font-size-smg">购买信息</p>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">购买课程</div>
                        <div class="flex" style="flex: 1">
                            <img :src="orderDetailInfo.goodCover" alt="">
                            <div style="flex: 1">
                                <p>{{ orderDetailInfo.goodTitle }}</p>
                                <p>￥{{ orderDetailInfo.orderFee }}</p>
                            </div>

                        </div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">支付金额</div>
                        <div>￥{{ orderDetailInfo.orderFee }}</div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">购买人</div>
                        <div>{{ orderDetailInfo.buyerName }}</div>
                    </div>

                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">订单来源</div>
                        <div v-if="orderDetailInfo.liveDistFlag==1">小程序推广计划</div>
                        <div v-else-if="orderDetailInfo.orderSourceDict=='zhibo'">直播</div>
                        <div v-else-if="orderDetailInfo.orderSourceDict=='guazai'">视频挂载</div>
                        <div v-else-if="orderDetailInfo.orderSourceDict=='doudian'">抖店</div>
                        <div v-else>平台订单</div>
                    </div>

                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">支付时间</div>
                        <div>{{ orderDetailInfo.payDate }}</div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">支付方式</div>
                        <div>
                            <span v-if="orderDetailInfo.payPlatform=='weixin'">微信</span>
                            <span v-else-if="orderDetailInfo.payPlatform=='zhifubao'">支付宝</span>
                            <span v-else>其他</span>
                        </div>
                    </div>

                    <!--          <div class="orderDetailConItem font-size-smg flex">-->
                    <!--            <div class="conItemL">交易单号</div>-->
                    <!--            <div>{{orderDetailInfo.payDate}}</div>-->
                    <!--          </div>-->

                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">手机号</div>
                        <div>{{ orderDetailInfo.buyerMobile }}</div>
                    </div>
                </div>

                <div class="orderDetailCon">
                    <p class="font-size-smg">推广明细</p>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">收益金额</div>
                        <div v-if="orderDetailInfo.distFee&&orderDetailInfo.distFee!=''">￥{{ orderDetailInfo.distFee }}</div>
                        <div v-else>￥0.00</div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">分佣比例</div>
                        <div v-if="orderDetailInfo.liveDistFlag==1">{{ orderDetailInfo.liveDistRatio }}%</div>
                        <div v-else-if=" orderDetailInfo.distCustomRatio">{{ orderDetailInfo.distCustomRatio }}%</div>
                        <div v-else>0%</div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">推广人</div>
                        <div v-if="orderDetailInfo.weixinId!=''" class="flex" style="align-items: center">
                            <img v-if="distUserInfo&&distUserInfo.avatar" style="width: 32px;height: 32px;border-radius: 50%" :src="distUserInfo.avatar" alt="">
                            <div v-if="orderDetailInfo.distName">{{ orderDetailInfo.distName }}</div>
                            <div v-else-if="orderDetailInfo.distMobile">{{ orderDetailInfo.distMobile.slice(0,3) }}****{{ orderDetailInfo.distMobile.slice(7) }}</div>
                            <!-- <div v-else>{{ distUserInfo.name}}</div> -->
                        </div>
                    </div>
                </div>

                <div class="orderDetailCon">
                    <p class="font-size-smg">课程收益</p>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">实际收益</div>
                        <div>￥{{ orderDetailInfo.authorFee }}</div>
                    </div>
                    <div class="orderDetailConItem font-size-smg flex">
                        <div class="conItemL">下单时间</div>
                        <div>{{ orderDetailInfo.createDate }}</div>
                    </div>
                </div>

            </div>

        </el-drawer>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    computed: {
        orderDetailInfo() {
            return this.$store.state['zsm-order'].orderDetailInfo || ''
        },
        distUserInfo() {
            return this.$store.state['zsm-order'].distUserInfo || ''
        }
    },
    methods: {

    },
    created() {

    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import "../style/order-modal";
</style>
